<template>
  <div class="loginmian">
    <div class="logincard">
      <div class="titleStyle">
        <span>围栏计算系统</span>
      </div>
      <el-form class="loginFromStyle" ref="loginFormRef" :model="loginFrom" :rules="loginFromRules">
        <!-- 用户名 -->
        <el-form-item class="loginItem" prop="username">
          <el-input
            v-model="loginFrom.username"
            placeholder="请输入用户名"
            prefix-icon="iconfont icon-icon-user-fill"
          ></el-input>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item class="loginItem" prop="password">
          <el-input
            v-model="loginFrom.password"
            placeholder="请输入密码"
            prefix-icon="iconfont icon-icon-password-fill"
            show-password
            @keyup.enter.native = 'loginFn'
          ></el-input>
        </el-form-item>

        <el-form-item class="btnStyle">
          <el-button class="btnStyleItem" type="primary" round @click="loginFn">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import aes from "@/utils/aes"; // 加密方法
import { Message } from "element-ui"; // 引入消息提示，不单独引样式有些问题
import { loginHttp } from "@/utils/api"; // 调登录接口

export default {
  name: "FenceLogin",
  data() {
    return {
      loginFrom: {
        username: "",
        password: ""
      },
      loginFromRules: {
        username: [
          { required: true, message: "请输入登录名称", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },

  methods: {
    // 登录
    loginFn() {
      // 兜底校验
      this.$refs.loginFormRef.validate(async valid => {
        // 如果校验未通过直接返回
        if (!valid) return;

        const encryptPassword = aes.encrypt(this.loginFrom.password); // 密码加密

        // 构造登录数据
        const loginData = {
          customerName: this.loginFrom.username,
          customerPwd: encryptPassword
        };

        // 获取登录接口
        const { data } = await loginHttp(loginData);

        if (data.code !== 0) {
          // 登录失败，提示错误信息
          Message({
            message: data.message,
            type: "error"
          });
          this.loginFrom.password = '' // 登录失败密码置空
          return;
        }

        if (data.code == 0) {
          // 登录成功提示
          Message({
            message: "登录成功",
            type: "success"
          });
          
          // 存token
          window.sessionStorage.setItem("token", data.token);

          // 路由跳转主界面
          this.$router.push("/home");
        }
      });
    }
  }
};
</script>

<style scoped>
.loginmian {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: url(../assets/background.png) no-repeat center center;
  background-size: cover;
}
.logincard {
  width: 400px;
  height: 325px;
  border-radius: 12px;
  overflow: hidden;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 7px 8px rgba(0, 15, 52, 0.089);
}
.titleStyle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 16%;
  background-color: #409eff;
  letter-spacing: 4px;
  font-size: 20px;
  font-weight: 500;
  color: rgb(255, 255, 255);
}
.loginFromStyle {
  padding: 40px 30px;
  width: 100%;
  /* background-color: rgb(172, 172, 172); */
}
.loginItem {
  width: 100%;
}
.btnStyle {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.btnStyleItem {
  width: 300px;
}
</style>
